import Logo from 'assets/logo-rgb.svg'
import styled from 'styled-components'

export default styled(Logo)`
  height: 45px;
`



// WEBPACK FOOTER //
// ./src/components/logo.jsx